<template>
  <div>
    <PageBanner 
      title="Careers" 
      imageSrc="../assets/images/rice-7176354_1280.jpg" 
      altText="Career Banner" 
    />
    <CareersForm />
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue';
import CareersForm from '@/components/CareersForm.vue';


export default {
  name: "ContactView",
  components: {
    PageBanner,
    CareersForm
  },
};
</script>
